

export  const warehousingRouting =[
	{
    path: "/assetManage/warehousing/list",
    name: "warehousing-list",
    meta: { title: "资产入库" },
    component: () =>
      import(/* webpackChunkName: "warehousing-list" */ "@/views/asset-management/warehousing/warehousing-list/index.vue"),
  },
	{
    path: "/assetManage/warehousing/create",
    name: "warehousing-create",
    meta: { title: "新建资产入库" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "warehousing-create" */ "@/views/asset-management/warehousing/form-create/index.vue"),
  },
	{
    path: "/assetManage/warehousing/edit/:id",
    name: "warehousing-edit",
    meta: { title: "编辑资产入库" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "warehousing-create" */ "@/views/asset-management/warehousing/form-create/index.vue"),
  },
	{
    path: "/assetManage/warehousing/detail/:id",
    name: "warehousing-detail",
    meta: { title: "资产入库详情" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "warehousing-detail" */ "@/views/asset-management/warehousing/form-detail/index.vue"),
  },
]

